import React from 'react'


import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
} from 'react-share';


import {
  ShareButtons,
} from 'react-share';






const SocialMediaButtons = (props) => (

  <div>
  
    <FacebookShareButton
      url={props.url}
      quote={`${'I counted the numbers from 3 to 11 and completed the lightbulb game in a mega fast time - can you beat me?'} ${props.text} ${props.seconds} ${props.text2} ${' '}`}
      hashtag={"#LightbulbGame"}>
      <FacebookIcon size={32} round={true} />
      
    </FacebookShareButton>
    {' '}
    <TwitterShareButton
      url={props.url}
      title={`${'I counted the numbers from 3 to 11 and completed the lightbulb game'} ${"\uD83D\uDCA1"} ${' in a mega fast time'} ${"\u23F1"} ${'- can you beat me?'} ${"\u26A1"} ${props.text} ${props.seconds}  ${props.text2} ${' '}`}
      via={props.via}>
      <TwitterIcon size={32} round={true} /> 
    </TwitterShareButton>
    {' '}
    <EmailShareButton
      subject= {'I counted the numbers from 3 to 11 and completed the lightbulb game in a mega fast time - can you beat me?'}
      body={`${props.text} ${props.seconds} ${props.text2}`}
      url={props.url}
      >
    <EmailIcon size={32} round={true} />
    </EmailShareButton>
    {' '}
    <WhatsappShareButton
      title= {'I counted the numbers from 3 to 11 and completed the lightbulb game in a mega fast time - can you beat me?'}
      separator={`${' '} ${props.text} ${props.seconds} ${props.text2} ${' '}`}
      url={props.url}
      >
    <WhatsappIcon size={32} round={true} />
    </WhatsappShareButton>



    </div>

)

export default SocialMediaButtons
